<template>
    <div class="carousel-wrapper" v-if="currentSlides.length > 0">
      <div class="carousel-container">
        <!-- 轮播图主体 -->
        <div 
          class="carousel" 
          @mouseenter="pauseTimer"
          @mouseleave="startTimer"
        >
          <div 
            class="carousel-content" 
            :style="carouselStyle"
            @touchstart="touchStart"
            @touchmove="touchMove"
            @touchend="touchEnd"
          >
            <div 
              v-for="(slide, index) in currentSlides" 
              :key="index" 
              class="carousel-item"
              :class="{ 'active': currentIndex === index }"
            >
              <div class="carousel-item-bg" v-if="slide.type == 3"></div>
              <div v-else>
                <a class="carousel-item-bg" :href="slide.articleHref" target="_blank" v-if="slide.articleHref != ''">
                  <BaseImage 
                  :src="slide.image" 
                  :alt="slide.alt"
                  aspect-ratio="16/9"
                  class="carousel-image"
                  />
                  <!-- <div class="text_area_bg" v-if="slide.title !='' && slide.content !=''"></div> -->
                  <div class="carousel-text" v-if="slide.title !='' && slide.content !=''">
                    <h2>{{ slide.title }}</h2>
                    <p>{{ slide.content }}</p>
                  </div>
                </a>
                <div v-else>
                  <BaseImage 
                  :src="slide.image" 
                  :alt="slide.alt"
                  aspect-ratio="16/9"
                  class="carousel-image"
                  />
                  <!-- <div class="text_area_bg" v-if="slide.title !='' && slide.content !=''"></div> -->
                  <div class="carousel-text" v-if="slide.title !='' && slide.content !=''">
                    <h2>{{ slide.title }}</h2>
                    <p>{{ slide.content }}</p>
                  </div>
                </div>
              </div>       
            </div>
          </div>
          <!-- 箭头 -->
          <button class="carousel-arrow left" @click="prev">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path 
                fill="currentColor" 
                d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
              />
            </svg>
          </button>
          <button class="carousel-arrow right" @click="next">
            <svg viewBox="0 0 24 24" width="24" height="24">
              <path 
                fill="currentColor" 
                d="M8.59 16.59L10 18l6-6-6-6-1.41 1.41L13.17 12z"
              />
            </svg>
          </button>
  
          <!-- 指示器 -->
          <div class="carousel-indicators">
            <span 
              v-for="(_, index) in slides" 
              :key="index"
              :class="{ active: currentIndex === index }"
              @click="goToSlide(index)"
            ></span>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
    import BaseImage from '@/components/common/BaseImage.vue'
    import { homeApi } from '@/api/home'
    
    export default {
      name: 'Carousel',
      components: {
        BaseImage
      },
      data() {
        return {
          currentIndex: 0,
          timer: null,
          touchStartX: 0,
          slides: [],
          slides2: [
            { image: '/src/assets/images/fv/h_banner1.jpg' },
            { image: '/src/assets/images/fv/h_banner2.jpg' },
            { image: '/src/assets/images/fv/h_banner3.jpg' }
          ],
          currentSlides: []
        }
      },
      computed: {
        carouselStyle() {
          return {
            transform: `translateX(-${this.currentIndex * 100}%)`,
            transition: 'transform 0.8s cubic-bezier(0.4, 0, 0.2, 1)'
          }
        }
      },

      methods: {
        async getBannerList() {
          try {
            const bannerList = await homeApi.getBannerList()

            // 初始化 slides 数组
            // console.log('bannerList:', bannerList.data)
            if (Array.isArray(bannerList.data)) {
              this.slides = bannerList.data.map(item => {
                // console.log('item:', item)
              const isMobile = window.innerWidth <= 768
              const image = isMobile ? item.mobile_pic : item.pc_pic
              const alt = isMobile ? item.mobile_pic_alt : item.pc_pic_alt
              const type = isMobile ? item.mobile_pic_type : item.pc_pic_type
              return {
                image,
                title: item.pic_title,
                content: item.pic_content,
                type,
                articleHref: item.article_href,  // 添加 article_href
                alt: item.alt
              }
              })
            }

            // 根据设备类型设置当前幻灯片
            this.currentSlides = this.slides

          } catch (error) {
            console.error('BannerList1111:', error)
            this.slides = error.data
          }
        },
        handleSlideClick(slide) {
          if (slide.type === 3) {
            console.log('播放视频:', slide.title)
            // 这里可以添加视频播放的具体实现
          } else {
            console.log('跳转到文章:', slide.articleHref)
            window.open(slide.articleHref, '_blank')  // 在新标签页中打开链接
          }
        },
        next() {
          this.currentIndex = (this.currentIndex + 1) % this.slides.length
        },
        prev() {
          this.currentIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length
        },
        goToSlide(index) {
          this.currentIndex = index
        },
        startTimer() {
          this.timer = setInterval(() => {
            this.next()
          }, 3000)
        },
        pauseTimer() {
          clearInterval(this.timer)
        },
        touchStart(e) {
          this.touchStartX = e.touches[0].clientX
          this.pauseTimer()
        },
        touchMove(e) {
          // e.preventDefault()
        },
        touchEnd(e) {
          const touchEndX = e.changedTouches[0].clientX
          const diff = touchEndX - this.touchStartX
    
          if (Math.abs(diff) > 50) {
            if (diff > 0) {
              this.prev()
            } else {
              this.next()
            }
          }
          this.startTimer()
        }
      },
      mounted() {
       
        this.startTimer()
        this.getBannerList()
      },
      beforeDestroy() {
        clearInterval(this.timer)
      }
    }
    </script>
  
  <style scoped>
  .carousel-wrapper {
    width: 100%;
    background-color: #000;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
  }
  
  .carousel-container {
    width: 100%;
    position: relative;
    overflow: hidden;
    aspect-ratio: 16 / 9; /* 设置宽高比 */
  }
  
  .carousel {
    width: 100%;
    height: 100%;
    position: relative;
    overflow: hidden;
  }
  
  .carousel-content {
    display: flex;
    width: 100%;
    height: 100%;
    will-change: transform;
  }
  
  .carousel-item {
    flex: 0 0 100%;
    position: relative;
    width: 100%;
    height: 100%;
    overflow: hidden;
  }
  
  .carousel-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }
  /* .text_area_bg{
    height: 200px;
    background-color: #00000050;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 1;
  } */
  .carousel-text {
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translate(-50%, -50%) scale(0.9);
    color: #fff;
    z-index: 2;
    opacity: 0;
    transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  }
  
  .carousel-item.active .carousel-text {
    opacity: 1;
    /* transform: translate(-50%, -50%) scale(1); */
  }
  
  .carousel-text h2 {
    font-size: clamp(1.5rem, 2vw, 2rem);
    text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
  }
  
  .carousel-text p {
    font-size: clamp(0.8rem, 1.5vw, 1.3rem);
    text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
    line-height: 2em;
  }
  
  .carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background: transparent;
    border: none;
    color: rgba(255, 255, 255, 0.8);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    z-index: 10;
  }
  
  .carousel-arrow:hover {
    background: rgba(0, 0, 0, 0.5);
    transform: translateY(-50%) scale(1.1);
  }
  
  .carousel-arrow svg {
    width: 30px;
    height: 30px;
  }
  
  .carousel-arrow.left {
    left: 30px;
  }
  
  .carousel-arrow.right {
    right: 30px;
  }
  
  @media (max-width: 768px) {
    .text_area_bg{
      height: 100px;
    }
    .carousel-arrow {
      width: 40px;
      height: 40px;
      display: none;
    }
  
    .carousel-arrow svg {
      width: 20px;
      height: 20px;
    }
  
    .carousel-arrow.left {
      left: 15px;
    }
  
    .carousel-arrow.right {
      right: 15px;
    }
    .carousel-container {
    width: 100%;
    position: relative;
    overflow: hidden;
    aspect-ratio: 125/159; /* 设置宽高比 */
  }
  }
  
  .carousel-indicators {
    position: absolute;
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 10px;
    z-index: 3;
  }
  
  .carousel-indicators span {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.5);
    cursor: pointer;
    transition: all 0.3s ease;
  }
  
  .carousel-indicators span.active {
    background: #fff;
    transform: scale(1.2);
  }
  
  @media (hover: none) {
    .carousel-content {
      touch-action: pan-y pinch-zoom;
    }
  }
  .carousel-text {
  position: absolute;
  left: 0; /* 将文字区域固定在左侧 */
  right: 0;
  bottom:-80px;  
  padding: 10px 8% 50px;
  background-color: #00000050;
  transform: translateY(-50%); /* 垂直居中 */
  color: #fff;
  z-index: 2;
  opacity: 0;
  transition: all 0.8s cubic-bezier(0.4, 0, 0.2, 1);
  text-align: left; /* 确保文字左对齐 */
}

.carousel-item.active .carousel-text {
  opacity: 1;
}

.carousel-text h2 {
  font-size: clamp(1.3rem, 3vw, 2.5rem); /* 使用clamp适配不同分辨率 */
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

  
  </style>